import Client from '../HttpClient';

const list = () => {
	return Client.get('/admin/api/course');
};

const find = (code) => {
	return Client.get(`/admin/api/course/${code}`);
};

const create = (payload) => {
	return Client.post('/admin/api/course', payload);
};

const update = (code, payload) => {
	return Client.put(`/admin/api/course/${code}`, payload);
};

const remove = (code) => {
	return Client.del(`/admin/api/course/${code}`);
};

const sort = (payload) => {
	return Client.put(`/admin/api/course/arrange`, payload);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	sort,
};
